import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import { reaction } from "mobx";
import { Toastr } from "arv-reactcomponents";
import { Checkout } from "npmlinks-constants";

@inject("CheckoutStore")
@observer
class BreachHandler extends Component {
  constructor() {
    super();
    this.triggerLimitBreachReaction = this.triggerLimitBreachReaction.bind(
      this,
    );
    this.triggerSkusNotAdded = this.triggerSkusNotAdded.bind(this);
    this.handleApiError = this.handleApiError.bind(this);
  }
  componentDidMount() {
    this.triggerLimitBreachReaction();
    this.triggerSkusNotAdded();
    this.handleApiError();
    this.handlePricingError();
  }
  handleApiError() {
    reaction(
      () => this.props.CheckoutStore.error,
      error => {
        if (error) {
          Toastr.showToastr({
            className: "nwc-toastr-list-danger nw-toastr",
            message: Checkout.CHECKOUT_MESSAGES.ERROR_MESSAGE,
            timeout: 3000,
          });
          this.props.CheckoutStore.clearError();
        }
      },
    );
  }
  triggerLimitBreachReaction() {
    reaction(
      () => this.props.CheckoutStore.breachMessages,
      breachMessages => {
        Toastr.setConfig({
          limitTo: breachMessages.length || 1,
        });
        breachMessages.forEach(message => {
          Toastr.showToastr({
            className: "nwc-toastr-list-danger nw-toastr",
            message,
            timeout: 3000,
          });
        });
        Toastr.setConfig({
          limitTo: 1,
        });
      },
    );
  }
  triggerSkusNotAdded() {
    reaction(
      () => this.props.CheckoutStore.skusNotAdded,
      skus => {
        if (skus.length > 0) {
          Toastr.showToastr({
            className: "nwc-toastr-list-danger nw-toastr",
            message: Checkout.CHECKOUT_MESSAGES.SKU_NOT_ADDED_MESSAGE,
            timeout: 3000,
          });
        }
      },
    );
  }
  handlePricingError() {
    const data = this.props.CheckoutStore.itemsHavingIssueInPricing;
    const products = data && data.length === 1 ? "product" : "products";
    reaction(
      () => data,
      skuId => {
        if (skuId.length > 0) {
          Toastr.showToastr({
            className: "nwc-toastr-list-danger nw-toastr",
            message: Checkout.CHECKOUT_MESSAGES.SKU_NOT_ADDED_MESSAGE.replace(
              "$count",
              data.length,
            ).replace("$product", products),
            timeout: 3000,
          });
        }
      },
    );
  }

  render() {
    const { children } = this.props;
    if (!children) {
      return null;
    }
    return <div className="nw-breachhandler">{children}</div>;
  }
}

BreachHandler.wrappedComponent.propTypes = {
  children: PropTypes.node.isRequired,
  CheckoutStore: PropTypes.shape({
    clearError: PropTypes.func.isRequired,
    error: PropTypes.shape({}).isRequired,
    breachMessages: PropTypes.shape([]).isRequired,
    skusNotAdded: PropTypes.shape([]).isRequired,
    itemsHavingIssueInPricing: PropTypes.arrayOf(PropTypes.shape({}))
      .isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("CheckoutStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: BreachHandler.wrappedComponent,
  component: BreachHandler,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CheckoutComponents/BreachHandler/index.js